import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Authentication',
  baseUrl: '',
  routes: [
    {
      path: '/admin/login',
      page: 'AdminLogin',
      title: 'Admin Login',
      exact: true
    },
    {
      path: '/admin/login-warehouse',
      page: 'AdminWarehouse',
      title: 'Admin Warehouse Login',
      exact: true
    },
    {
      path: '/admin/login-busk',
      page: 'AdminBusk',
      title: 'Admin Busk Login',
      exact: true
    },
    {
      path: '/admin/login-forwarder',
      title: 'Forwarder Login',
      exact: true,
      page: 'AdminForwarder'
    },
    {
      path: '/admin/login-seller-api',
      title: 'Seller API Login',
      exact: true,
      page: 'AdminSellerApi'
    },
    {
      path: '/admin/login-warehouse-api',
      title: 'Warehouses API Login',
      exact: true,
      page: 'AdminWarehouseApi'
    }
  ],
  requireAuthenticated: false
};

export default config;
